import * as Sentry from '@sentry/react';

type Args = {
  isUserAuth: boolean;
  userEmail?: string | null;
  userId?: string | null;
  userType?: string | null;
  username?: string | null;
};

export function setSentryTags({
  isUserAuth,
  userEmail,
  userId,
  userType,
  username,
}: Args) {
  if (isUserAuth) {
    Sentry.setUser({
      email: userEmail || undefined,
      id: userId || undefined,
      type: userType,
      username: username || undefined,
    });
    Sentry.setTag('user.type', userType);
    Sentry.setTag('user.email', userEmail);
    Sentry.setTag('user.id', userId);
    Sentry.setTag('user.username', username);
  } else {
    Sentry.setUser({});
    Sentry.setTag('user.type', 'anonymous');
    Sentry.setTag('user.email', null);
    Sentry.setTag('user.id', null);
    Sentry.setTag('user.username', null);
  }
}
